var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvert7444812(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    fill: "#2162e3",
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m65 86.52 18-10.4a2 2 0 0 0 1-1.73v-20.78a2 2 0 0 0 -1-1.73l-18-10.4a2 2 0 0 0 -2 0l-18 10.4a2 2 0 0 0 -1 1.73v20.78a2 2 0 0 0 1 1.73l18 10.4a2.05 2.05 0 0 0 2 0zm1-5.2v-16.17l14-8.08v16.17zm-2-35.8 14 8.09-14 8.08-14-8.08zm-16 11.55 14 8.08v16.17l-14-8.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m104 64a40 40 0 1 0 -40 40 40 40 0 0 0 40-40zm-76 0a36 36 0 1 1 36 36 36 36 0 0 1 -36-36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m110.4 81.66a2 2 0 0 0 -2.24 1.18l-.14.34a48 48 0 0 1 -44.02 28.82 2 2 0 0 0 0 4 52 52 0 0 0 44-24.27v10.27a2 2 0 0 0 4 0v-18.38a2 2 0 0 0 -1.6-1.96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m64 16a2 2 0 0 0 0-4 52 52 0 0 0 -44 24.26v-10.26a2 2 0 0 0 -4 0v18.37a2 2 0 0 0 1.6 2 1.81 1.81 0 0 0 .4 0 2 2 0 0 0 1.84-1.21 48 48 0 0 1 44.16-29.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert7444812);
export default __webpack_public_path__ + "static/media/convert_7444812.b866f41df8072b7ff0cf0510199b3a0b.svg";
export { ForwardRef as ReactComponent };